<template>
    <div class="container maxBoxContainer">
        <div class="brandTitleDiv">
            <p class="brandTitleP textBase">ya solo queda un último paso</p>
        </div>
        <div class="whiteBack">
            <div class="featherTitle">
                <img src="../../assets/images/iconPluma.png" class="img-fluid icoPluma" alt="EnergyGo">

                <span class="featherText textBase">Firma tu solicitud</span>
            </div>
            <div class="dniZone">
                <div class="btnZone">
                    <p class="infoDni roboto400">Introduce tu NIF para visualizar y firmar tu solicitud.</p>
                    <input type="nif" class="inputDni" @input="checkNif" @change="checkNif" maxlength="9" id="dni"
                        ref="inputNif" placeholder="NIF">
                    <button class="buttonNext buttonText btn-block" id="buttonNext" ref="btnNext" @click="goResume" :disabled="disabledButton">
                        {{ nextContent }}
                        <img src="../../assets/images/loading.svg" class="spinner" id="spinnerNext" v-if="showSpinner" alt="spinnerNext" />
                    </button>
                    <div>
                        <p id="red_dni" v-if="errorLetter" class="errorText roboto400">{{ err }}</p>
                    </div>
                </div>
                <div class="checkbox checkSecureAccess roboto400">
                    <input type="checkbox" @click="toogleCheck" id="acepto" value="1">
                    <label for="acepto" class="padLeft10">
                        Acepto que inicio un proceso de firma digital.
                    </label>
                    <span class="linkCondition" @click="$bvModal.show('modalLegal'), openPopUp()">Más detalles</span>
                </div>
            </div>
        </div>
        <!-- footerLogo -->
        <footer-main/>
        <!-- footerLogo -->
        <!-- LegalText -->
        <b-modal id="modalLegal" no-close-on-backdrop hide-footer hide-header size="lg" scrollable content-class="modalLegalText">
            <div class="modalLegalClose">
                <img src="../../assets/images/icocerrar.png" @click="$bvModal.hide('modalLegal'), closeErrorUp()" alt="close" />
            </div>
            <div class="d-block text-center">
                <div v-for="(item, index) in legalText" :key="index">
                    <p v-html="sanitize(item)" class="pLegalText roboto400"/>
                </div>
            </div>
        </b-modal>
        <!-- LegalText -->
    </div>
</template>
<script>
import Vue from 'vue';
import VueResource from 'vue-resource';
Vue.use(VueResource)
window.$ = window.jQuery = require('jquery');

import constants from '../../assets/environments/constants.json';
import errorsList from '../../assets/environments/errors.json';
import impLegalText from '../../assets/environments/legalText.json';

export default {
    name: 'secureAccess',
    data() {
        return {
            err: 'Tienes que introducir un número válido',
            nextContent: 'Siguiente',
            map : new Map([['#url#',`${document.location.protocol}//${window.location.host}${this.$route.path}`]]),
            nif: null,
            validCheck: false,
            validDni: false,
            errorLetter: false,
            errorUp: false,
            nifLabel: false,
            linkTo: '',
            payload: {
              id_container: "",
              id_notification: "",
              client: ""
            },
            disabledButton: false,
            refactorEnv: {},
            popUp: false,
            channel: '',
            legalText: impLegalText,
            login_token : '',
            showSpinner: false
        }
    },
    created() {
        this.$session.start()
        this.linkTo = window.location.href
        this.changeEnv()

    },
    mounted() {
        var vm = this
        vm.nif = vm.$refs.inputNif
        vm.btnNext = vm.$refs.btnNext
        vm.popUp = vm.$refs.popUpCondition
        vm.upSide = vm.$refs.upSide
        vm.nifLabel = vm.$refs.nifLabel
        vm.checkCondition = vm.$refs.checkCondition
        this.$emit('changeVeil', false, false)
        this.$bus.$emit('event-changeStep', constants.secureView)
    },
    methods: {
        checkNif() {
            this.err = 'Tienes que introducir un número válido'
            var vm = this
            let cont = vm.nif.value
            this.floatNif()
            if (cont.length > constants.lengthDNIMax && this.controlNieDniCif(vm.nif.value)) {
                this.validDni = true
                this.errorLetter = false
            }
            else {
                this.errorLetter = true
                this.validDni = false
            }
        },
        toogleCheck() {
            var vm = this
            if (this.validCheck == true) {
                this.validCheck = false
            }
            else {
                this.validCheck = true
            }
        },
        floatNif() {
            var vm = this
            if (vm.nif.value != "") {
                this.nifLabel = true;
            }
            else {
                this.nifLabel = false;
            }
        },
        controlNieDniCif(nif) {
            const nifRegEx = new RegExp(/^[0-9]{8,8}[A-Za-z]$/)
            const nieRegEx = new RegExp(/^[XYZxyz][0-9]{7}[A-Za-z]$/)
            const cifRegEx = new RegExp(/^[a-zA-Z]{1}[0-9]{7}[a-jA-J0-9]{1}$/)
            if (nifRegEx.test(nif) || nieRegEx.test(nif) || cifRegEx.test(nif)) { return true }
            return false
        },
        login(tokenSend) {
            this.$session.set('token',tokenSend)
            this.$router.push({
                name:'resumeContract',
                params:{
                    token: tokenSend
                }
            })
        },
        async getUrlParams() {
            var vm = this
            this.payload.id_notification = this.$route.params.id_notification
            this.payload.id_container = this.$route.params.id_container
            this.payload.client = this.refactorEnv.client
            this.channel = this.$route.query.channel
            if (this.channel == 'web') {
                var response = await this.get_token()
                if(response == true){this.login(this.login_token)}
                else{this.go_to_error(response)}
            }
            else{
                let url_go = vm.refactorEnv.go
                var payloadGo={'id_container':this.$route.params.id_container, 'id_notification': this.$route.params.id_notification}
                await this.$http.post(url_go, payloadGo,{})
                .then(response => (
                    this.checkSignatureState(response)
                )).catch((error) =>{
                    this.checkError(constants.unknowError)
                })
            }
        },
        async goResume() {
            var vm = this
            vm.disabledButton = true
            vm.nextContent = ""
            vm.showSpinner = true
            vm.btnNext.classList.add('buttonDisabled')
            vm.btnNext.classList.remove('buttonNext')
            if (!vm.validCheck){
                this.errorLetter = true
                this.err = 'Debe marcar la casilla para continuar'
            }else{
                this.payload.id_client = vm.nif.value
                var response = await this.get_token()
                if(response == true){this.login(this.login_token)}
                else{this.go_to_error(response)}
            }
            vm.showSpinner = false
            vm.disabledButton = false
            vm.nextContent = 'Siguiente'
            vm.btnNext.classList.add('buttonNext')
            vm.btnNext.classList.remove('buttonDisabled')

        },
        closeErrorUp() {
            this.errorUp = false
            this.$emit('changeVeil', false, false)
        },
        openPopUp() {
            this.$emit('changeVeil', true, false)
        },
        closePopUp() {
            this.$emit('changeVeil', false, false)
        },
        moveView() {
            window.scrollTo(constants.lengthZero, constants.lengthZero);
        },
        checkError(errorStatus) {
            var error = constants.unknowError
            for (let i in errorsList) {
                if (i == errorStatus) { error = errorStatus }
            }
            return error
        },
        checkSignatureState(response)
        {
            var signatureState = response.body.id_notification_status
            if(signatureState == constants.statusSigned)
            {
                var urlToGo =  response.body.url_ok
                window.location.href = urlToGo
            }else if (signatureState == constants.statusCanceledByAgent || signatureState == constants.statusCanceledByClient)
            {
                var urlToGo =  response.body.url_ko
                window.location.href = urlToGo
            }
        },
        changeEnv() {
            var vm = this
            jQuery.when(
                jQuery.getJSON('../../assets/environments/environment.json')
            ).always(function (data) {
                vm.refactorEnv = data.settings
                vm.getUrlParams()
                vm.$session.set("setting", vm.refactorEnv);
            });
        },
        async get_token(){
            var vm = this
            let urlLog = vm.refactorEnv.loginUrl
            let headers = {
                'Content-Type': 'application/json;charset=utf-8',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Credentials': 'true'
            };
            var is_token = true
            await this.$http.post(urlLog,this.payload, {headers: headers})
                .then(response => (
                    vm.login_token = response.data.authorization_token
                )).catch((error) =>{
                    is_token = error.status
                })
            return is_token
        },
        go_to_error(response){
            var vm = this
            if(response == constants.dataIncorrect || response == constants.unauthorized || response == constants.not_found){
                this.err = 'El NIF introducido no se corresponde con el titular'
                this.errorUp = true
                this.errorLetter = true
            }
        },
        sanitize(str){
            this.map.forEach((value,key)=>{
            str = str.replace(new RegExp(key,'g'),value);
            });
            return str;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/secureAccess/secureAccess.vue